var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.7794,
    cy: 46.7794,
    r: 46.7794,
    fill: "url(#paint0_linear_257_2595)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2597 48.0358L33.1636 69.3461L34.2564 24.8327L72.2597 48.0358Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_257_2595",
    x1: 46.7794,
    y1: 0,
    x2: 46.7794,
    y2: 93.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF679C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.530034,
    stopColor: "#EA73B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC85D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/PlayButton.14372f8cc311bd80d4e97e2d49d0c14b.svg";
export { ForwardRef as ReactComponent };